import Error from 'next/error'
import { Localized } from 'fluent-react/compat';

function ErrorPage({ statusCode, title }) {
  const i18n = <Localized id={title} />;
  return <Error statusCode={statusCode} title={i18n} />
}

export default ErrorPage;